import clsx from "clsx";
import { PropsWithChildren } from "react";

type TextScreenReaderOnlyProps = {
  className?: string;
};

export function TextScreenReaderOnly(
  props: PropsWithChildren<TextScreenReaderOnlyProps>,
) {
  return (
    <span className={clsx(props.className, "sr-only")}>{props.children}</span>
  );
}
